import React, { useEffect, useState } from 'react'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'

const ModalCase4 = ({
  amenitiesDefinitions,
  isOpen,
  master = '',
  child = '',
  onSubmit,
  onUndo,
  dictionary,
}) => {
  // const { dictionary } = window.bookingData || window.modifyData
  const [records, setRecords] = useState([])

  useEffect(() => {
    setRecords(amenitiesDefinitions)
  }, [])

  const masterTitle = () => {
    return master ? records.find((i) => i.code === master)?.name || '' : ''
  }

  const childTitle = () => {
    return child ? records.find((i) => i.code === child)?.name || '' : ''
  }

  const text = () => {
    const value = `<strong>${childTitle()}</strong>`
    return dictionary.modalCase4Text.replace('{0}', value)
  }

  const handleUndo = () => {
    onUndo()
  }

  const handleSubmit = () => {
    onSubmit(master, child)
  }

  return (
    <div
      id="modalCase4"
      className={`modal s-modal s-modal--warning  ${
        isOpen ? 'show d-block' : ''
      }`}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              <div>
                <i className="icon-warning"></i>
              </div>
              <div>{dictionary.modalCase4Title}</div>
            </div>
          </div>
          <div className="modal-body">
            <div>
              <SanitizeHtml tag="p" html={text()} />
            </div>
            <ul className="b-extras-as-badges-list">
              <li>
                <div className="e-extra-as-badge">{masterTitle()}</div>
              </li>
            </ul>
          </div>
          <div className="modal-footer">
            <ul>
              <li>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={handleUndo}
                  title={dictionary.modalCase4ButtonUndoText}>
                  {dictionary.modalCase4ButtonUndoText}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  title={dictionary.modalCase4ButtonSubmitText}>
                  {dictionary.modalCase4ButtonSubmitText}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCase4
